import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 5,
    fontSize: 22,
  },
  button: {
    width: 20,
    height: 20,
    textAlign: 'center',
    '&[disabled]': {
      '& svg': {
        color: '#999',
        opacity: 0.5,
      },
    },
  },
  inputWrapper:{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  input:{
    width:'4ch',
    heigh:'100%',
    background: 'transparent',
    border: 'none',
    outline: 'none',
  },
  inputError:{
    color: '#FF0000 !important',
    cursor:'help',
  },
}));

export default useStyles;
